/**
 * Split a proof metric into a leading numeral and the rest of the sentence.
 *
 * Shared by the offer template and the service-page proof block so the two
 * cannot drift. The offer template had its own copy of this, matching only
 * `40%`-style openings; service pages had none at all and rendered every metric
 * as a flat line of body text.
 *
 * THE METRICS ARE ATTRIBUTED CONTENT. This decides where to break the line, not
 * what the line says. Where a metric had to be reordered so its figure comes
 * first — "Operating across 21 cities in 9 US states" to "21 cities across 9 US
 * states" — that was done in the data, deliberately, and the figures themselves
 * are untouched.
 *
 * Forms accepted as a leading value:
 *   40%      percentage
 *   50       bare count
 *   1,200    thousands separator
 *   3x       multiple
 *   24/7     a ratio read as one figure — this is why the pattern is not just
 *            digits: "24/7 voice agent creating leads directly in Odoo" would
 *            otherwise render with no numeral at all despite opening with one.
 *   $3,500   a price used as the headline figure
 *
 * Returns { value, label }. `value` is null when the metric opens with no
 * figure, and the caller decides what to do about that — no figure is ever
 * invented to fill the slot.
 */
const LEADING = /^(\$?\d[\d,.]*\s*%|\$?\d[\d,.]*\s*\/\s*\d+|\$?\d[\d,.]*x|\$?\d[\d,.]*)\s+(.*)$/

export const splitMetric = metric => {
  const m = String(metric).match(LEADING)
  if (!m) return { value: null, label: String(metric) }
  // Trim a trailing full stop off the numeral side only; "1,200." reads wrong
  // set at $fs-stat.
  return { value: m[1].replace(/\s+/g, "").replace(/\.$/, ""), label: m[2] }
}

export default splitMetric
